<template>
  <div class="public-review">
    <div class="public-review-header flex mb-20">
      <div class="public-review-header-wrapper">
        <div class="public-review-rating">
          <vz-icon 
            name="star" 
            size=19
            class="mr-5"
            variant="white"
          />
          <span>{{ rating }}</span>
        </div>
        <div class="public-review-date ml-20">
          {{ date }}
        </div>
      </div>
      <nuxt-link class="public-review-link ml-auto" :to="review.url" target="_blank">
        <img :src="imgUrl" class="public-review-link-img" :alt="review.type"/>
        <vz-icon
          name="chevron-right"
          variant="dark-gray"
          size=14
          class="ml-5"
        />
      </nuxt-link>
    </div>
    <div class="public-review-body" :class="{ show }">
      <div class="public-review-text mb-20">
        <div ref="visibleTextBlock" class="public-review-text-visible">
          <div ref="textBlock" class="public-review-text-block">
            {{ review.text }}
          </div>
        </div>
        <div v-if="hasShow" class="show-link vz-cursor-pointer" @click="onClick">
          {{ showLinkTitle }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { formatDate } from '~/common/date';
import { PublicReview } from '~/types/public';

const props = defineProps({
  review: {
    type: Object as PropType<PublicReview>,
    default: () => {}
  }
})

const hasShow = ref(false)
const show = ref(false)
const visibleTextBlock = ref()
const textBlock = ref()

const rating = computed(() => {
  return props.review?.rating ? `${props.review.rating}.0` : ''
})

const date = computed(() => {
  return formatDate(props.review?.date)
})

const isTypeYandex = computed(() => {
  return props.review?.type === 'yandex'
}) 

const imgUrl = computed(() => {
  return isTypeYandex.value ? '/images/pages/groupage-cargo/yandex-maps.webp' : '/images/pages/groupage-cargo/2gis.webp'
})

const showLinkTitle = computed(() => {
  return show.value ? 'Закрыть' : 'Читать'
})

function onClick() {
  show.value = !show.value
}

onMounted(() => {
  if (visibleTextBlock.value?.clientHeight < textBlock.value?.clientHeight) {
    hasShow.value = true
  }
})
</script>

<style lang="scss" scoped>
.public-review {
  @media screen and (max-width: $pub-xs) {
    max-width: 264px;
    width: 100%;
  }

  &-header {
    @media screen and (max-width: $pub-xs) {
      flex-direction: column;
    }

    &-wrapper {
      display: flex;
      align-items: center;
    }
  }

  &-rating {
    background-color: $primary;
    color: $white;
    font-size: 18px;
    line-height: 22px;
    font-weight: 500;
    border-radius: 64px;
    width: 90px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &-date {
    color: $font-lower;
  }

  &-link {
    border: 1px solid $border-gray;
    border-radius: 64px;
    padding: 0px 18px;
    height: 40px;
    display: flex;
    align-items: center;
    color: $font-dark !important;
    background-color: $pure-white;

    @media screen and (max-width: $pub-xs) {
      margin-left: 0 !important;
      margin-right: auto;
      margin-top: 20px;
    }

    &:hover {
      text-decoration: none;
      border-color: $font-light;
    }
  }

  &-body {
    border-bottom: 2px solid $font-lower;

    &.show {
      border-color: $primary;

      .public-review-text-visible {
        height: auto !important;
        max-height: 146px;
        overflow-y: auto;
      }
    }
  }

  &-text {
    padding: 20px 20px 10px 20px;
    background-color: $box-gray;
    border-radius: 4px;
    min-height: 135px;

    .public-review-text-visible {
      height: 72px;
      overflow: hidden;
    }
  }

  .show-link {
    text-decoration: underline;
    color: $font-lower; 
    width: 65px;
    margin-left: auto;
    margin-top: 5px;
    text-align: right;

    &:hover {
      color: $font-dark;
    }
  }
}
</style>
  